import React from 'react';

const NotificationSnapshotFormModal = React.lazy(() => import('../components/FormModal'));
const notificationSnapshotModalRegistry = {
    notification_notificationSnapshotId: NotificationSnapshotFormModal
};
export default notificationSnapshotModalRegistry;
